module.exports = __webpack_public_path__ + "img/audit_log.8b790027.svg";